import loadable from '@loadable/component';

export const MrdSiteWrapper = loadable(
  () => import(/* webpackChunkName: "mrd-site" */ './MrdSiteWrapper'),
);
